const routes = {
    "/signin": { showHeader: false },
    "/signup": { showHeader: false },
    "/resetpassword": { showHeader: false },
    "/addnewuserpassword": { showHeader: false },
    "/forgot-password": { showHeader: false },
    "/account-created": { showHeader: false },
    "/landing-page-editor": { showHeader: true },
    "/landing-page-settings/\\d": { showHeader: true },
    "/landing-page-editor/\\d": { showHeader: true },
    "/landing-page-publish/\\d": { showHeader: true },
    "/landing-page-list/\\d": { showHeader: true },
    "/edit-landing-page/\\d": { showHeader: true },
    "/journey-builder/create-new-journey": { showHeader: false },
    "/individualCampaign/component/\\d/\\w/\\w/\\d": { showHeader: false },
    "/journey-builder/\\d": { showHeader: false},
    "/not-found": { showHeader: false},
    "/preview": { showHeader: false},
    "/journey-buildera/fetch/\\d": { showHeader: false}
};

/**
 *
 * @param {string} pathname
 * @returns
 */
export function checkRouteIsExcluded(pathname) {
    for (const route in routes) {
        if (new RegExp(route).test(pathname.toLowerCase())) {
            return routes[route];
        }
    }
    return false;
}
